import './ProductDetail.scss';
import Component from './ProductDetail.js';
export default Component;
